import { VIEW_MODES, type ViewMode } from './view-mode';

/**
 * Cards or table.
 *
 * A pair of `aria-pressed` buttons rather than radios or a `<select>`: both options are visible at
 * once, either is one click away from the other, and the pressed state says which one you are
 * looking at without a label having to. It sits at the END of the status bar — after the count and
 * the active filters — because it is about how to read the answer, and the answer comes first.
 */

const LABELS: Record<ViewMode, string> = { cards: 'כרטיסים', table: 'טבלה' };

export function ViewSwitch({ view, onChange }: { view: ViewMode; onChange: (view: ViewMode) => void }) {
  return (
    <div className="tenders-seg" role="group" aria-label="תצוגת תוצאות">
      {VIEW_MODES.map((mode) => (
        <button
          key={mode}
          type="button"
          className="tenders-seg__btn"
          aria-pressed={view === mode}
          onClick={() => onChange(mode)}
        >
          {LABELS[mode]}
        </button>
      ))}
    </div>
  );
}
